import React from "react";

const SocialIcon = ({ icon, color, href }) => {
    return (
        <div
            className="social-icon"
            style={{ backgroundColor: color }}
            onClick={() => {
                window.open(href, "_blank");
                
            }}
        >
            {icon}
        </div>
    );
};

export default SocialIcon;
